import { TrayArrowDownIcon } from '@phosphor-icons/react'
import { TooltipWrapper } from 'app/components/ui/tooltip-wrapper'

/**
 * Marks the list's default stage in its lane's label row. An icon rather than a line under the
 * label, so the default lane's cards start level with every other lane's.
 */
export function DefaultStageMark() {
  return (
    <TooltipWrapper
      message="Default stage: new entries, and anyone without a stage yet, start here"
      className="flex shrink-0 self-center text-subtle"
    >
      <TrayArrowDownIcon size={14} weight="bold" aria-hidden />
      <span className="sr-only">Default stage</span>
    </TooltipWrapper>
  )
}
